import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../core/contexts/AuthContext';
import { getDefaultRedirectPath } from '../core/utils/authHelpers';

export default function UnauthorizedPage() {
  const { t } = useTranslation('errors');
  const { userRoles } = useAuth();
  const navigate = useNavigate();

  const handleGoBack = () => {
    const redirectPath = getDefaultRedirectPath(userRoles);
    navigate(redirectPath);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Lock Icon */}
          <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-red-100 mb-6">
            <svg
              className="h-12 w-12 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {t('unauthorized.heading.title')}
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            {t('unauthorized.text.description')}
          </p>
        </div>

        <div className="bg-white py-8 px-4 shadow-sm rounded-lg sm:px-10">
          <div className="space-y-4">
            <p className="text-sm text-gray-700">
              {t('unauthorized.text.reasonsIntro')}
            </p>
            <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 ml-2">
              <li>{t('unauthorized.text.reason1')}</li>
              <li>{t('unauthorized.text.reason2')}</li>
              <li>{t('unauthorized.text.reason3')}</li>
              <li>{t('unauthorized.text.reason4')}</li>
            </ul>

            <div className="pt-6 flex flex-col gap-3">
              <button
                onClick={handleGoBack}
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {t('unauthorized.button.goToDashboard')}
              </button>

              <Link
                to="/"
                className="w-full inline-flex justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {t('unauthorized.button.goToHome')}
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            {t('unauthorized.text.needHelp')}{' '}
            <a
              href="mailto:support@example.com"
              className="text-indigo-600 hover:text-indigo-500 font-medium"
            >
              {t('unauthorized.link.contactSupport')}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
